<script setup lang="ts">
import { computed } from 'vue'
import { capitalize } from '@/util/strings'
import CharacteristicsSummary from './CharacteristicsSummary.vue'
import SDIStrategiesResultsSection from './SDIStrategiesResultsSection.vue'
import type { GeneratedStrategies, StudentCharacteristic, UdlGuideline } from './sdi_types'

const props = withDefaults(defineProps<{
  generatedStrategies: GeneratedStrategies
  selectedCharacteristics?: StudentCharacteristic[]
  traceId?: string
}>(), {
  selectedCharacteristics: () => [],
  traceId: '',
})

const emit = defineEmits<{
  reset: []
}>()

const DISPLAY_ORDER: UdlGuideline[] = ['engagement', 'representation', 'expression']

const strategySections = computed(() => DISPLAY_ORDER.map((guideline) => ({
  guideline: capitalize(guideline),
  strategies: props.generatedStrategies[guideline],
})))

const strategyCount = computed(() => strategySections.value.reduce((count, section) => count + section.strategies.length, 0))
</script>

<template>
  <div>
    <p role="status" class="sr-only">Generated {{ strategyCount }} instructional strategies</p>
    <CharacteristicsSummary :characteristics="selectedCharacteristics" @reset="emit('reset')" />
    <div class="mt-8 rounded-lg bg-gradient-to-r from-ai-bluePinkStart from-50% to-ai-bluePinkStop p-0.5">
      <div class="rounded-md bg-white p-5">
        <SDIStrategiesResultsSection
          v-for="section in strategySections"
          :key="section.guideline"
          :guideline="section.guideline"
          :strategies="section.strategies"
          :trace-id="traceId"
        />
      </div>
    </div>
  </div>
</template>
